import { render } from "./BrandLogo.vue?vue&type=template&id=471c5066&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"

import "./BrandLogo.vue?vue&type=style&index=0&id=471c5066&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471c5066"]])

export default __exports__